/**
 * Labstep
 *
 * @module components/Group/Item
 * @desc Item component for group
 */

import { Size } from 'labstep-web/core/Initials/types';
import type React from 'react';
import { GroupInitials } from '../Initials';
import styles from './styles.module.scss';
import type { GroupItemProps } from './types';

export const GroupItem: React.FC<GroupItemProps> = ({
  group,
  truncate,
}) => (
  <div
    data-testid={`group-initials-${group.id}`}
    className={styles.item}
    style={{
      maxWidth: truncate ? '400px' : 'none',
    }}
  >
    <GroupInitials group={group} size={Size.mini} />
    <div
      className={styles.name}
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {group.name}
    </div>
  </div>
);
